// Model.js
// -----------------------
// @module Case
define("BTM.SEOPriceCurrency.SEOPriceCurrency.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/SEOPriceCurrency.Service.ss"
            )
        )
        
});
});
